import React, { useState, useEffect, useCallback } from "react";
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import InfiniteScroll from 'react-infinite-scroll-component';

/* for "axios" request cancelation */
import axios from 'axios';

/* Services */
import DoctorService from "../../../../services/doctor.service";

/* Ant Design */
import { Typography, Col, Card, Button, Row, Tag, Image, Tooltip, Dropdown, Menu, Spin } from 'antd';
import { DownOutlined } from '@ant-design/icons';

/* for "axios" request cancelation check variable */
let source;

let Kategori = ['Tümü'], EgzersizTipi = ['Tümü'];

const StoreGames = (props) => {
    const [fetchedGames, setFetchedGames] = useState([]);
    const [kategori, setKategori] = useState([]);
    const [selectedKategori, setSelectedKategori] = useState(null);
    const [egzersizTipi, setEgzersizTipi] = useState([]);
    const [selectedEgzersizTipi, setSelectedEgzersizTipi] = useState(null);
    const [ucret, setUcret] = useState(['Tümü', 'Ücretli', 'Ücretsiz']);
    const [selectedUcret, setSelectedUcret] = useState(null);
    const [pageLimit, setPageLimit] = useState(10);
    const [totalCount, setTotalCount] = useState(0);
    const [loadingGames, setLoadingGames] = useState(false);

    // page - limit - category - exerciseType - priceType
    const getExactQuery = useCallback((() => {
        const query = new URLSearchParams(props.location.search);
        const reqPage = query.get('page');
        const reqLimit = query.get('limit');
        const reqCategory = query.get('category');
        const reqExerciseType = query.get('exerciseType');
        const reqPriceType = query.get('priceType');
        const exactQuery = {};

        reqPage && (exactQuery.page = reqPage);
        reqLimit && (exactQuery.limit = reqLimit);
        reqCategory && (exactQuery.category = reqCategory);
        reqExerciseType && (exactQuery.exerciseType = reqExerciseType);
        reqPriceType && (exactQuery.priceType = reqPriceType);

        return exactQuery;
    }), [props.location.search]);

    useEffect(() => {
        source = axios.CancelToken.source();

        setLoadingGames(true);

        getGamesCategoriesAndExerciseTypes();
        getGames(getExactQuery, source.token);
        return () => {
            if (source) {
                source.cancel();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getGames = (query, cancelToken) => {
        setLoadingGames(true);

        DoctorService.getGames(query, cancelToken)
            .then(
                res => {
                    let query = '';
                    res.data.metaData.page && (query += ('?page=' + res.data.metaData.page));
                    res.data.metaData.limit && (query += ('&limit=' + res.data.metaData.limit));
                    res.data.metaData.category && (query += ('&category=' + res.data.metaData.category.replaceAll(' ', '+')));
                    res.data.metaData.exerciseType && (query += ('&exerciseType=' + res.data.metaData.exerciseType.replaceAll(' ', '+')));
                    res.data.metaData.priceType && (query += ('&priceType=' + res.data.metaData.priceType));

                    props.history.push({
                        pathname: '',
                        search: query
                    });

                    if (res.data.Games && ([...fetchedGames, ...res.data.Games].length <= res.data.metaData.totalCount)) {
                        setFetchedGames(firstDatas => [...firstDatas, ...res.data.Games]);
                    }
                    if (res.data.Games && res.data.metaData.page === 1) {
                        setFetchedGames(res.data.Games);
                    }

                    setSelectedKategori(res.data.metaData.category);
                    setSelectedEgzersizTipi(res.data.metaData.exerciseType);
                    setTotalCount(res.data.metaData.totalCount);
                    if (res.data.metaData.totalCount === 0) {
                        toast.warning("Oyun Bulunamadı!");
                    }
                    setLoadingGames(false);
                },
                error => {
                    const resMessage =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();

                    if (resMessage !== 'Cancel') {
                        toast.error(resMessage, { autoClose: 3000 });
                        setLoadingGames(false);
                    }
                }
            )
    }

    const getGamesCategoriesAndExerciseTypes = () => {
        DoctorService.getGamesCategoriesAndExerciseTypes(source.token)
            .then(
                res => {
                    Kategori = ['Tümü'];
                    EgzersizTipi = ['Tümü'];
                    Kategori = Kategori.concat(res.data.Categories);
                    EgzersizTipi = EgzersizTipi.concat(res.data.Exercises);

                    setKategori(Kategori);
                    setEgzersizTipi(EgzersizTipi);
                },
                error => {
                    const resMessage =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();

                    if (resMessage !== 'Cancel') {
                        toast.error(resMessage, { autoClose: 3000 });
                        setLoadingGames(false);
                    }
                });
    }

    const getNextGames = () => {
        let query = getExactQuery();
        query.page = parseInt(query.page) + 1;
        console.log("page: " + typeof query.page + " - " + query.page);
        getGames(query, source.token);
    }

    const filterKategori = (category) => {
        setFetchedGames([]);
        setTotalCount(0);

        let query = getExactQuery();
        query.page = 1;

        if (category !== 'Tümü') {
            setSelectedKategori(category);
            let replacedCategory = category.replaceAll(' ', '+');
            query.category = replacedCategory;
            getGames(query, source.token);
        } else {
            setSelectedKategori(null);
            query.category = null;
            getGames(query, source.token);
        }
    }

    const filterEgzersizTipi = (exercise) => {
        setFetchedGames([]);
        setTotalCount(0);

        let query = getExactQuery();
        query.page = 1;

        if (exercise !== 'Tümü') {
            setSelectedEgzersizTipi(exercise);
            let replacedExercise = exercise.replaceAll(' ', '+');
            query.exerciseType = replacedExercise;
            getGames(query, source.token);
        } else {
            setSelectedEgzersizTipi(null);
            query.exerciseType = null;
            getGames(query, source.token);
        }
    }

    const filterUcret = (price) => {
        setFetchedGames([]);
        setTotalCount(0);

        let query = getExactQuery();
        query.page = 1;

        if (price !== 'Tümü') {
            setSelectedUcret(price);
            let replacedUcret = false;
            if (price === 'Ücretli') {
                replacedUcret = "false";
            } else if (price === 'Ücretsiz') {
                replacedUcret = "true";
            }
            query.priceType = replacedUcret;
            getGames(query, source.token);
        } else {
            setSelectedUcret(null);
            query.priceType = null;
            getGames(query, source.token);
        }
    }

    const resetFilter = () => {
        let query = getExactQuery();
        query.category = null;
        query.exerciseType = null;
        query.priceType = null;

        setFetchedGames([]);
        setTotalCount(0);
        setSelectedKategori(null);
        setSelectedEgzersizTipi(null);
        setSelectedUcret(null);

        getGames(query, source.token);
    }

    let gamesCount = 0;

    return (
        <div>
            <div>
                {/* Title */}
                <Typography.Title style={{ textAlign: 'center' }}>
                    Oyunlar
                </Typography.Title>
                <div>
                    <Row gutter={[16, 16]}>
                        <Col xs={24} sm={24} md={14} lg={14} xl={14} xxl={6}>
                            {/* Filter */}
                            <Row gutter={[16, 16]}>
                                {/* Kategori */}
                                <Col>
                                    <Dropdown
                                        overlay={
                                            <Menu
                                                selectable={true}
                                                selectedKeys={selectedKategori !== null ? [selectedKategori] : ['Tümü']}
                                            >
                                                {Kategori.map(Kategori =>
                                                    <Menu.Item
                                                        key={Kategori}
                                                        onClick={(e) => { filterKategori(Kategori) }}
                                                    >
                                                        {Kategori}
                                                    </Menu.Item>
                                                )}
                                            </Menu>}
                                        placement="bottomCenter"
                                        arrow
                                    >
                                        <Button style={{ backgroundColor: '#FFF2E8', color: '#d4380d', borderColor: '#ffbb96' }}>Kategori<DownOutlined style={{ fontSize: '80%' }} /></Button>
                                    </Dropdown>
                                </Col>
                                {/* Egzersiz Tipi */}
                                <Col>
                                    <Dropdown
                                        overlay={
                                            <Menu
                                                selectable={true}
                                                selectedKeys={selectedEgzersizTipi !== null ? [selectedEgzersizTipi] : ['Tümü']}>
                                                {EgzersizTipi.map(EgzersizTipi =>
                                                    <Menu.Item
                                                        key={EgzersizTipi}
                                                        onClick={(e) => { filterEgzersizTipi(EgzersizTipi) }}
                                                    >
                                                        {EgzersizTipi}
                                                    </Menu.Item>
                                                )}
                                            </Menu>
                                        }
                                        placement="bottomCenter"
                                        arrow
                                    >
                                        <Button style={{ backgroundColor: '#fff0f6', color: '#c41d7f', borderColor: '#ffadd2' }}>Egzersiz Tipi<DownOutlined style={{ fontSize: '80%' }} /></Button>
                                    </Dropdown>
                                </Col>
                                {/* Ücret */}
                                <Col>
                                    <Dropdown
                                        overlay={
                                            <Menu selectable={true} selectedKeys={selectedUcret !== null ? [selectedUcret] : ['Tümü']}>
                                                {ucret.map(Ucret =>
                                                    <Menu.Item key={Ucret} onClick={(e) => { filterUcret(Ucret) }}>
                                                        {Ucret}
                                                    </Menu.Item>
                                                )}
                                            </Menu>
                                        }
                                        placement="bottomCenter"
                                        arrow
                                    >
                                        <Button style={{ backgroundColor: '#f6ffed', color: '#389e0d', borderColor: '#b7eb8f' }}>Ücret<DownOutlined style={{ fontSize: '80%' }} /></Button>
                                    </Dropdown>
                                </Col>
                                {/* Temizle */}
                                {(selectedKategori || selectedEgzersizTipi || selectedUcret) &&
                                    <Col>
                                        <Button style={{ border: 'none', boxShadow: 'none' }} onClick={resetFilter}>Temizle</Button>
                                    </Col>
                                }
                            </Row>
                        </Col>
                        <Col xs={0} sm={0} md={2} lg={2} xl={2} xxl={14}></Col>
                        {(fetchedGames.length > 0 || totalCount > 0) &&
                            <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={4}>
                                <Typography.Title level={5} style={{ textAlign: 'end' }}>
                                    <b>{fetchedGames.length} / {totalCount}</b> Adet Oyun Listelendi</Typography.Title>
                                <div style={{ clear: 'both' }}></div>
                            </Col>
                        }
                    </Row>
                </div>
                {/* Datas */}
                {fetchedGames.length > 0 ?
                    <InfiniteScroll
                        dataLength={fetchedGames.length}
                        next={getNextGames}
                        hasMore={((totalCount > fetchedGames.length) && (fetchedGames.length > 0)) ? true : false}
                        style={{ overflowX: "hidden" }}
                        loader={(loadingGames || totalCount !== fetchedGames.length) &&
                            <div style={{ textAlign: 'center', marginTop: '5vh' }}>
                                <Spin />
                            </div>
                        }
                        endMessage={
                            (totalCount === fetchedGames.length) && (fetchedGames.length > 0) &&
                            <p style={{ textAlign: 'center', marginTop: '5vh' }}>
                                <b>Listenin Sonuna Ulaştınız!</b>
                            </p>
                        }
                    >
                        <Row gutter={[8, 32]} style={{ marginTop: '2vh' }}>
                            {fetchedGames &&
                                fetchedGames.map(game => (
                                    <Col xs={24} md={12} lg={8} xl={6} xxl={4} key={game._id}>
                                        <Card
                                            size="small"
                                            hoverable
                                            style={((gamesCount + 1) % 2 === 0) ? {
                                                backgroundColor: '#e6f7ff', borderRadius: "20px",
                                                overflow: "hidden"
                                            } : {
                                                backgroundColor: '#FFFFFF', borderRadius: "20px",
                                                overflow: "hidden"
                                            }}
                                            cover={
                                                <Image
                                                    preview={false}
                                                    width={'100%'}
                                                    src={game.PhotoLink}
                                                    alt={game.OyunAdi}
                                                    fallback="data:image/png;base64,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"
                                                />
                                            }
                                            actions={[
                                                <Button style={{
                                                    width: '90%',
                                                    borderRadius: "20px",
                                                    overflow: "hidden",
                                                    backgroundColor: '#f0f5ff'
                                                }} block>Detay</Button>
                                            ]}
                                            onClick={() => { props.history.push("/doctor/store/games/detail?game=" + game._id); }}
                                            hidden={!(
                                                (selectedKategori === null || selectedKategori === game.KategoriID.KategoriAdi)
                                                &&
                                                (selectedEgzersizTipi === game.EgzersizTipiID.EgzersizTipiAdi || selectedEgzersizTipi === null)
                                                &&
                                                (selectedUcret === null || (selectedUcret === 'Ücretli' && !game.Free) || (selectedUcret === 'Ücretsiz' && game.Free))
                                            )}
                                        >
                                            <Card.Meta
                                                title={
                                                    <Typography.Title level={5} ellipsis='true'>
                                                        <Tooltip title={game.OyunAdi}>
                                                            {game.OyunAdi}
                                                        </Tooltip>
                                                    </Typography.Title>
                                                }
                                                description={
                                                    <Typography.Text>
                                                        {game.OyunAciklama ? game.OyunAciklama : 'Oyun Açıklaması Bilgisine Ulaşılamadı!'}
                                                    </Typography.Text>
                                                }
                                            />
                                            <br />
                                            <p style={{ display: 'none' }}>{gamesCount += 1}</p>
                                            <Row gutter={[8, 12]} style={{ width: '100%' }}>
                                                <Col span={24}>
                                                    <Tag
                                                        color="volcano"
                                                        style={{ whiteSpace: "normal", height: 'auto', marginBottom: '10px' }}
                                                    >
                                                        {game.KategoriID ? game.KategoriID.KategoriAdi : 'Kategori Bilgisine Ulaşılamadı!'}
                                                    </Tag>
                                                </Col>
                                                <Col span={24}>
                                                    <Tag
                                                        color="magenta"
                                                        style={{ whiteSpace: "normal", height: 'auto', marginBottom: '10px' }}
                                                    >
                                                        {game.EgzersizTipiID ? game.EgzersizTipiID.EgzersizTipiAdi : 'Egzersiz Tipi Bilgisine Ulaşılamadı!'}
                                                    </Tag>
                                                </Col>
                                                <Col span={24}>
                                                    {
                                                        game.Free === true ?
                                                            <Tag color="green">Ücretsiz</Tag>
                                                            :
                                                            <Tag color="red">
                                                                Ücretli
                                                            </Tag>
                                                    }
                                                </Col>
                                            </Row>
                                        </Card>
                                    </Col>
                                ))
                            }
                        </Row>
                    </InfiniteScroll>
                    :
                    <div style={{ textAlign: 'center', marginTop: '5vh' }}>
                        <Spin />
                    </div>
                }
            </div>
        </div>
    )
}

const mapState = (state) => ({
});

const mapDispatch = (dispatch) => ({
});

export default connect(mapState, mapDispatch)(StoreGames);